// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Orders_Payments_Types from "../Restaumatic.Orders.Payments.Types/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Orders_Payments_Types.eqChannelInfo));
var channelsIsSymbol = {
    reflectSymbol: function () {
        return "channels";
    }
};
var GetPaymentChannelsResponseIsSymbol = {
    reflectSymbol: function () {
        return "GetPaymentChannelsResponse";
    }
};
var GetPaymentChannelsResponse = function (x) {
    return x;
};
var toFillFormTypeGetPaymentC = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeGetPaymentChannels = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGetPaymentChannel = function (dictHasField) {
    return dictHasField;
};
var eqGetPaymentChannelsRespo = {
    eq: function (x) {
        return function (y) {
            return eq(x.channels)(y.channels);
        };
    }
};
var genericGetPaymentChannelsResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetPaymentChannelsResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(channelsIsSymbol)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Payments_Types.showChannelInfo)))))(GetPaymentChannelsResponseIsSymbol))
};
var unscrambleDecodeGetPaymentChannelsResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(channelsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Payments_Types.unscrambleDecodeChannelInfo))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodeGetPaymentChannelsResponse = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetPaymentChannelsResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(channelsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Payments_Types.encodeChannelInfo)))))))
};
var decodeGetPaymentChannelsResponse = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetPaymentChannelsResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(channelsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Payments_Types.decodeChannelInfo)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    GetPaymentChannelsResponse,
    genericGetPaymentChannelsResponse,
    eqGetPaymentChannelsRespo,
    showGetPaymentChannelsResponse,
    encodeGetPaymentChannelsResponse,
    decodeGetPaymentChannelsResponse,
    unscrambleDecodeGetPaymentChannelsResponse,
    toFillFormTypeGetPaymentC,
    hasFieldGetPaymentChannel,
    newtypeGetPaymentChannels
};
